import { FaVideo, FaBell, FaLaptop, FaMoon, FaLock, FaHeadset } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaVideo />, // Video icon
        title: 'CCTV Surveillance',
        description: 'Monitor your premises 24/7 with high-definition CCTV cameras for enhanced security.',
    },
    {
        id: 2,
        icon: <FaBell />, // Bell icon
        title: 'Motion Detection',
        description: 'Receive instant alerts when motion is detected, ensuring prompt response to suspicious activity.',
    },
    {
        id: 3,
        icon: <FaLaptop />, // Laptop icon
        title: 'Remote Access',
        description: 'Access your security systems remotely, ensuring peace of mind no matter where you are.',
    },
    {
        id: 4,
        icon: <FaMoon />, // Moon icon
        title: 'Night Vision',
        description: 'Ensure clear visibility even in low light conditions with advanced night vision capabilities.',
    },
    {
        id: 5,
        icon: <FaLock />, // Lock icon
        title: 'Access Control',
        description: 'Restrict access to sensitive areas with keyless entry systems and secure access control solutions.',
    },
    {
        id: 6,
        icon: <FaHeadset />, // Headset icon
        title: '24/7 Monitoring',
        description: 'Ensure your security systems are always operational with continuous monitoring and support.',
    },
];

export default features;